import { createSelector } from 'reselect';
import {
  RootReducerState,
  getAllProjects,
  getProjectsOverview,
  getProjectByIdState,
  getMyProjectIds,
} from '../../../apps/main/rootReducer';
import { Project } from '../../../models/Project';
import { ProjectId, ProjectTabViews } from '../../../models/Types';
import { ProjectByIdState } from '../reducers/projects';

export const getFavoriteProjects = createSelector<
  [
    (state: RootReducerState) => ProjectByIdState,
    (state: RootReducerState) => ProjectId[],
  ],
  Project[]
>(getProjectByIdState, getMyProjectIds, (byId, ids) =>
  ids
    .map((id) => byId[id])
    .filter((project) => project?.favorite)
    .sort((a: Project, b: Project) => {
      const numberCompare = a.number.localeCompare(b.number);
      if (numberCompare !== 0) return numberCompare;
      return a.name.localeCompare(b.name);
    })
);

export const getFavoriteProjectsWithMail = createSelector<
  [
    (state: RootReducerState) => ProjectByIdState,
    (state: RootReducerState) => ProjectId[],
  ],
  Project[]
>(getProjectByIdState, getMyProjectIds, (byId, ids) =>
  ids
    .map((id) => byId[id])
    .filter((project) => project?.favorite && project?.sharedMailboxUserId)
    .sort((a: Project, b: Project) => {
      const numberCompare = a.number.localeCompare(b.number);
      if (numberCompare !== 0) return numberCompare;
      return a.name.localeCompare(b.name);
    })
);

export const getFavoriteProjectsLength = createSelector<
  [
    (state: RootReducerState) => ProjectByIdState,
    (state: RootReducerState) => ProjectId[],
  ],
  number
>(
  getProjectByIdState,
  getMyProjectIds,
  (byId, ids) => ids.filter((id) => byId[id]?.favorite).length
);

export const projectsSelector = (type: ProjectTabViews) =>
  createSelector<
    [
      (state: RootReducerState) => Project[],
      (state: RootReducerState) => Project[],
    ],
    Project[]
  >(
    getProjectsOverview,
    getAllProjects,
    (projectsOverview: Project[], allProjects: Project[]) => {
      switch (type) {
        case 'all': {
          return projectsOverview;
        }
        case 'myProjects': {
          return allProjects;
        }
        case 'favorites': {
          return allProjects.filter((p) => p.favorite);
        }
        default: {
          return allProjects;
        }
      }
    }
  );
